import { render, staticRenderFns } from "./NewReplacement.vue?vue&type=template&id=04f8264a&"
import script from "./NewReplacement.vue?vue&type=script&lang=js&"
export * from "./NewReplacement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "NewReplacement.vue"
export default component.exports